import React from 'react';

const RenderDistance = (distance?: number, distanceDisplay?: string) => {
    if (distance && distanceDisplay) {
        // const distanceColorClass = (distance / 1000) < 200 ? 'green' : 'red';
        return (
            <div className="location-content-distance">
                <span className="distance-number">{distanceDisplay} km</span> away
            </div>
        );
    }

    return null;
};

export default RenderDistance;
